import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetAvailableTagsCommand } from "@/model/communication/application/GetAvailableTagsCommand";
import { GetAvailableTagsResponse } from "@/model/communication/application/GetAvailableTagsResponse";
import { GetServerConfigurationCommand } from "@/model/communication/application/GetServerConfigurationCommand";
import { GetServerConfigurationResponse } from "@/model/communication/application/GetServerConfigurationResponse";
import { GetStartupDataCommand } from "@/model/communication/application/GetStartupDataCommand";
import { GetStartupDataResponse } from "@/model/communication/application/GetStartupDataResponse";
import { GetSupportedModelsCommand } from "@/model/communication/application/GetSupportedModelsCommand";
import { GetSupportedModelsResponse } from "@/model/communication/application/GetSupportedModelsResponse";
import { AuthResponseEnum } from "@/model/communication/auth/Login/AuthResponseEnum";
import { LoginRequest } from "@/model/communication/auth/Login/LoginRequest";
import { GetBranchesCommand } from "@/model/communication/branch/GetBranchesCommand";
import { GetBranchesReqData } from "@/model/communication/branch/GetBranchesReqData";
import { GetBranchesResData } from "@/model/communication/branch/GetBranchesResData";
import { GetAllDenominationsCommand } from "@/model/communication/security/GetAllDenominationsCommand";
import { GetAllDenominationsResData } from "@/model/communication/security/GetAllDenominationsResData";
import { GetAvailableMachineModelsCommand } from "@/model/communication/status/GetAvailableMachineModelsCommand";
import { GetModelTreeCommand } from "@/model/communication/status/GetModelTreeCommand";
import { GetModelTreeResData } from "@/model/communication/status/GetModelTreeResData";
import { FetchAvailableSoftwareFiltersCommand, FetchAvailableSoftwareFiltersReqData } from "@/model/communication/updatesStatus/FetchAvailableSoftwareFiltersCommand";
import { FetchAvailableSoftwareFiltersResponse } from "@/model/communication/updatesStatus/FetchAvailableSoftwareFiltersResponse";
import router from "@/router";
import * as routes from "@/router/routes";
import { RootState } from "@/store";
import { ActionTree } from "vuex";
import { ApplicationState } from ".";
import { AUTO_LOGIN, LOGIN, VuexLoginRequest } from "../AuthenticationModule/actions";
import {
    SET_ALL_DENOMINATIONS,
    SET_APPLICATION_LOADED,
    SET_AVAILABLE_BRANCHES,
    SET_AVAILABLE_BRANCHES_INCLUDE_DELETED,
    SET_AVAILABLE_BRANCHES_INCLUDE_EMPTY,
    SET_AVAILABLE_MACHINE_MODELS,
    SET_AVAILABLE_SOFTWARE_VERSIONS,
    SET_AVAILABLE_SOFTWARE_VERSIONS_FETCHING,
    SET_AVAILABLE_SOFTWARE_VERSIONS_TYPE,
    SET_AVAILABLE_TAGS,
    SET_MODEL_TREE,
    SET_SERVER_CONFIGURATION,
    SET_STARTUP_DATA,
    SET_SUPPORTED_MODELS,
} from "./mutations";

export const APP_BOOTSTRAP = "APP_BOOTSTRAP";
export const GET_SUPPORTED_MODELS = "GET_SUPPORTED_MODELS";
export const GET_SERVER_CONFIGURATION = "GET_SERVER_CONFIGURATION";

// For filters
export const GET_AVAILABLE_BRANCHES = "GET_AVAILABLE_BRANCHES";
export const GET_AVAILABLE_BRANCHES_INCLUDE_EMPTY = "GET_AVAILABLE_BRANCHES_INCLUDE_EMPTY";
export const GET_AVAILABLE_BRANCHES_INCLUDE_DELETED = "GET_AVAILABLE_BRANCHES_INCLUDE_DELETED";
export const GET_AVAILABLE_MACHINE_MODELS = "GET_AVAILABLE_MACHINE_MODELS";
export const GET_AVAILABLE_SOFTWARE_VERSIONS = "GET_AVAILABLE_SOFTWARE_VERSIONS";
export const GET_AVAILABLE_TAGS = "GET_AVAILABLE_TAGS";

export const GET_ALL_DENOMINATIONS = "GET_ALL_DENOMINATIONS";
export const GET_MODEL_TREE = "GET_MODEL_TREE";

export default {
    /**
     * Metodo per il bootstrap dell'applicazione
     */
    async [APP_BOOTSTRAP]({ dispatch, commit, state, rootState }) {
        // startup data
        try {
            let res: GetStartupDataResponse = await new GetStartupDataCommand().execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) commit(SET_STARTUP_DATA, res.applicationStartupData);
        } catch (e) {
            console.error("GetStartupDataCommand().execute()", e);
            console.warn("Execute location.reload() to force the page refresh");
            location.reload();
        }

        try {
            // se è un link pubblico per la visualizzazione di una dashboard
            if (router.currentRoute.path.includes("dashboard") && router.currentRoute.query["st"]) {
                console.log("router.currentRoute", router.currentRoute);

                const loginRequest = new LoginRequest("", "", "", false, false, undefined, [], router.currentRoute.query["st"] as string, null, false);
                const callbackURL = router.currentRoute.path;
                let req: VuexLoginRequest = {
                    loginRequest,
                    callbackURL,
                };

                await dispatch(LOGIN, req);

                if (rootState.authMod.authState == AuthResponseEnum.Authenticated) state.tvMode = true;
            } // altrimenti provo l'auto login e aspetto qua a meno che non sia il reset della password
            else if (!router.currentRoute.path.includes(routes.ResetPassword)) await dispatch(AUTO_LOGIN);
        } catch (err) {
            console.error("Error in APP_BOOTSTRAP:", err);
        }

        commit(SET_APPLICATION_LOADED, true);
    },

    /**
     * Get all CIMA supported models informations
     */
    async [GET_SUPPORTED_MODELS]({ commit }) {
        let res: GetSupportedModelsResponse = await new GetSupportedModelsCommand().execute();
        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            if (res.models && res.models.length > 0) commit(SET_SUPPORTED_MODELS, res.models);
        }
    },

    /**
     * Get C-Link server configuration
     */
    async [GET_SERVER_CONFIGURATION]({ commit }) {
        try {
            let res: GetServerConfigurationResponse = await new GetServerConfigurationCommand().execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) commit(SET_SERVER_CONFIGURATION, res.configurationEntries);
        } catch (error) {
            console.error("Error new GetServerConfigurationCommand().execute();");
        }
    },

    // For filters
    async [GET_AVAILABLE_BRANCHES]({ commit }) {
        let res: GetBranchesResData = await new GetBranchesCommand().execute();

        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            if (res.availableBranches != null && res.availableBranches.length > 0) {
                commit(SET_AVAILABLE_BRANCHES, res.availableBranches);
            }
        }
    },

    async [GET_AVAILABLE_BRANCHES_INCLUDE_EMPTY]({ commit }) {
        let res: GetBranchesResData = await new GetBranchesCommand(new GetBranchesReqData(true, false)).execute();

        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            if (res.availableBranches != null && res.availableBranches.length > 0) {
                commit(SET_AVAILABLE_BRANCHES_INCLUDE_EMPTY, res.availableBranches);
            }
        }
    },

    async [GET_AVAILABLE_BRANCHES_INCLUDE_DELETED]({ commit }) {
        let res: GetBranchesResData = await new GetBranchesCommand(new GetBranchesReqData(true, true)).execute();

        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            if (res.availableBranches != null && res.availableBranches.length > 0) {
                commit(SET_AVAILABLE_BRANCHES_INCLUDE_DELETED, { branches: res.availableBranches, deletedBranches: res.deletedBranches });
            }
        }
    },

    async [GET_AVAILABLE_MACHINE_MODELS]({ commit }) {
        let res: ApiGenericResponse = await new GetAvailableMachineModelsCommand().execute();
        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            commit(SET_AVAILABLE_MACHINE_MODELS, res.payload);
        }
    },

    async [GET_AVAILABLE_SOFTWARE_VERSIONS]({ state, commit }, payload) {
        if (!state.availableSoftwareVersionsFetching) {
            commit(SET_AVAILABLE_SOFTWARE_VERSIONS_FETCHING, true);
            try {
                let versionType = "update";
                if (payload) versionType = payload;
                let res: FetchAvailableSoftwareFiltersResponse = await new FetchAvailableSoftwareFiltersCommand(new FetchAvailableSoftwareFiltersReqData(versionType)).execute();

                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    commit(SET_AVAILABLE_SOFTWARE_VERSIONS, res.availableSoftwareFilter);
                    commit(SET_AVAILABLE_SOFTWARE_VERSIONS_TYPE, payload);
                } else console.error("cannot fetch available software filters");
                commit(SET_AVAILABLE_SOFTWARE_VERSIONS_FETCHING, false);
            } catch (e) {
                commit(SET_AVAILABLE_SOFTWARE_VERSIONS_FETCHING, false);
            }
        }
    },

    async [GET_AVAILABLE_TAGS]({ state, commit }, force) {
        if (state.availableTags == null || state.availableTags.length == 0 || (force != null && force)) {
            try {
                let res: GetAvailableTagsResponse = await new GetAvailableTagsCommand().execute();

                if (res.responseStatus == ApiResponseStatusEnum.Success) commit(SET_AVAILABLE_TAGS, res.availableTags);
                else console.error("cannot fetch available tags for filters");
            } catch (e) {
                console.error("cannot fetch available tags for filters");
            }
        } else {
            console.debug("GET_AVAILABLE_TAGS: availableTags already loaded");
        }
    },

    async [GET_ALL_DENOMINATIONS]({ state, commit }) {
        try {
            if (state.allDenominations == null || state.allDenominations.length == 0) {
                let res: GetAllDenominationsResData = await new GetAllDenominationsCommand().execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) commit(SET_ALL_DENOMINATIONS, res.allDenominations);
                else console.error("cannot fetch denominations");
            }
        } catch (e) {
            console.error("cannot fetch denominations");
        }
    },
    async [GET_MODEL_TREE]({ commit }) {
        let res: GetModelTreeResData = await new GetModelTreeCommand().execute();
        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            commit(SET_MODEL_TREE, res.modelTree);
        }
    },
} as ActionTree<ApplicationState, RootState>;
